import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { actualizarEstadosDesconocido, getAllIngresados } from "../../../redux/actions";
import IngresadoRow from "./ingresadoRow";
import Navbar from "../../../components/navbar/navbarComponent";
import SuccessModal from "../../../components/modals/successModal";
import ErrorModal from "../../../components/modals/errorModal";
import { PlayCircleIcon } from "../../../components/icons/SvgIcons";
import Button from "../../../components/button";



function StockActualComponent() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [vehiculosIngresados, setVehiculosIngresados] = useState(true);
    useEffect(() => {
        const fetchVehiculosIngresados = async () => {
            try {
                const response = await dispatch(getAllIngresados(0));
                setVehiculosIngresados(response);
            } catch (error) {
                console.error("Error al obtener los vehículos ingresados", error);
            } finally {
                setLoading(false);
            }
        };
        fetchVehiculosIngresados();
    }, [dispatch]);



    const [checkedItems, setCheckedItems] = useState({});

    const handleCheckChange = (id) => {
        setCheckedItems((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const seleccionarTodos = () => {
        const nuevosChecks = {};
        vehiculosIngresados.forEach(({ id }) => {
            nuevosChecks[id] = true;
        });
        setCheckedItems(nuevosChecks);
    };

    const manejarActualizacionEstados = async () => {
        const idsNoSeleccionados = vehiculosIngresados
            .filter(({ id }) => !checkedItems[id])
            .map(({ id }) => id);

        try {
            await dispatch(actualizarEstadosDesconocido(idsNoSeleccionados));
            setMostrarModalExito(true);
        } catch (error) {
            console.error("Error al actualizar estados:", error);
            setMostrarModalError(true);
        }
    };

    const [mostrarModalExito, setMostrarModalExito] = useState(false);
    const [mostrarModalError, setMostrarModalError] = useState(false);

    return (
        <div className="bg-[#F5FAFF] flex flex-col justify-center">
            {mostrarModalExito && (
                <SuccessModal closeSuccessModal={() => {
                    setMostrarModalExito(false);
                    navigate(0)
                  }}/>
            )}
            {mostrarModalError && (
                <ErrorModal closeErrorModal={() => setMostrarModalError(false)} message={"Ocurrió un error"}/>
            )}
            <Navbar />
            <div className="min-h-screen">
                <div className="flex  flex-col items-center w-full h-full gap-8">
                    <div className="flex-col justify-center items-start sm:items-center text-start inline-flex mt-[1rem] sm:mt-[4rem] w-[20rem] sm:w-[32rem]">
                        <div className="text-[#3d4245] sm:text-[2rem] text-[1rem] font-bold font-inter">
                            Stock actual
                        </div>
                        <div className="text-[#687073] sm:text-lg text-s font-medium font-inter inline-flex">
                            <PlayCircleIcon className="size-6" />

                            Selecciona los vehículos que se encuentran actualmente en corralón
                        </div>
                        <div className="text-[#687073] sm:text-lg text-s font-medium font-inter inline-flex">
                            <PlayCircleIcon className="size-6" />
                            Al final de la lista encontrará el botón para completar la operación
                        </div>
                        <div className="text-[#687073] sm:text-lg text-s font-medium font-inter inline-flex">
                            <PlayCircleIcon className="size-6" />
                            Los vehículos no seleccionados pasarán a tener estado "Desconocido"
                        </div>
                    </div>
                </div>

                <div className="mx-auto mb-[3rem] mt-[1rem] rounded-lg border border-[#c5dfff] flex flex-col overflow-hidden sm:w-[32rem] w-[20rem]">
                    {/* Encabezado */}
                    <div className="flex items-center bg-[#c5dfff] h-[3.5rem] px-4">
                        <div className="text-start text-[#0a5477] text-xs font-bold font-inter uppercase flex-[0.5]">
                            Nro Acta
                        </div>
                        <div className="text-center text-[#0a5477] text-xs font-bold font-inter uppercase flex-1">
                            Marca / Modelo
                        </div>
                        <div className="text-center text-[#0a5477] text-xs font-bold font-inter uppercase flex-1">
                            Dominio
                        </div>
                        <div className="text-center text-[#0a5477] text-xs font-bold font-inter uppercase flex-[0.5]">
                            {/* Acción */}
                            <Button
                                type="button"
                                variant="secondary"
                                size="xs"
                                onClick={seleccionarTodos}
                            >
                                Seleccionar todos
                            </Button>
                        </div>
                    </div>

                    {loading ? (
                        <div className="text-center py-4">Cargando vehículos...</div>
                    ) : (
                        vehiculosIngresados?.map(({ Acta, Vehiculo, id }) => (
                            <IngresadoRow
                                key={id}
                                actaNro={Acta?.nro || "Sin Acta"}
                                marcaModelo={
                                    Vehiculo
                                        ? `${Vehiculo.marcavh} / ${Vehiculo.modelovh}`
                                        : "Sin información"
                                }
                                dominio={Vehiculo?.dominio || "Sin dominio"}
                                checked={!!checkedItems[id]}
                                onCheck={() => handleCheckChange(id)}
                            />
                        ))
                    )}
                </div>
            </div>
            <Button
                size="md"
                onClick={manejarActualizacionEstados}
                className="mx-auto mb-[3rem] block"
            >
                Actualizar estados
            </Button>
        </div>
    );
}

export default StockActualComponent;